/** Formato do relatório em `GET /v1/Campanha/exportar` — o back recebe o número. */
export enum RelatorioFormato {
  Pdf = 1,
  Excel = 2,
}
